import React, { useContext } from 'react'
import { t } from 'i18next'
import { Button, Card, Tag } from 'antd'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import GlobalContext from '../GlobalContext'

const stateMessage = (appointment, box) => {
  return (
    <div >
      <div>{box.name} - {box.interphone}</div>
      <div>{dayjs(appointment.begin_date).format('H[h]mm')}-${dayjs(appointment.end_date).format('H[h]mm')}</div>
      <div>{appointment.digicode}</div>
    </div>
  )
}

export default function AppointmentCard ({ appointment }) {
  const { boxes } = useContext(GlobalContext)

  const title = (<div style={{ padding: '1em 0' }}>
    <div style={{ color: t(`Admin.Appointment.stateColor.${appointment.state}`) }}>
      {appointment.name}
    </div>
    <div><Tag color={t(`Admin.Appointment.stateColor.${appointment.state}`)} >{t(`Admin.Appointment.state.${appointment.state}`)}</Tag></div>
    <div>+{appointment.phone}</div>

  </div>)
  return (
    <Card title={title}
      actions={[
        <Link key='edit' to={`/admin/appointments/${appointment.id}?from=list`}><Button>Edition</Button></Link>
      ]}>
      {stateMessage(appointment, boxes.find(box => box.id === appointment.box_id))}
    </Card>
  )
}
